import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;

@Component({
  selector: 'app-celebs-love-us',
  templateUrl: './celebs-love-us.component.html',
  styleUrls: ['./celebs-love-us.component.css']
})
export class CelebsLoveUsComponent extends BaseClass<any> implements OnInit {
  modalRef?: BsModalRef;
  config = {
    keyboard: false,
    class: 'celebsModal exposureModal modal-sm'
  };

  constructor(public service: WebserviceService,
    private modalService: BsModalService) {
    super(document);
   }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  playvideo(template: TemplateRef<any>, id:any)
  {
    var name;
    switch(id) { case '1': name = 'SHAKTI KAPOOR'; break; case '2': name = 'KARISHMA TANNA'; break; case '3': name = 'MADALSA SHARMA'; break; case '4': name = 'ZOYA AFROZ'; break; case '6': name = 'DEEPSHIKHA NAGPAL'; break; case '7': name = 'AMIT TANDON'; break; case '8': name = 'AMBIKA RANJANKAR'; break; case '9': name = 'ADHYAYAN SUMAN'; break; case '10': name = 'RUSHAD RANA'; break; case '11': name = 'ROOPAL TYAGI'; break; case '12': name = 'FALAQ NAAZ'; break; case '13': name = 'SNEHA ULLAL'; break; case '14': name = 'KARAN PATEL'; break; case '15': name = 'DAISY SHAH'; break; case '16': name = 'SHAMITA SHETTY'; break; case '17': name = 'SAPNA CHOUDHARY'; break; case '18': name = 'HINA KHAN'; break; case '19': name = 'KAINAAT ARORA'; break; case '20': name = 'KAPPU'; break; case '21': name = 'KHUSHI GANDHAVI'; break; case '22': name = 'BHAVIKA KATARIYA'; break; case '23': name = 'BEBO NAMITA'; break; case '24': name = 'SUSHANT PAL'; break; case '25': name = 'SENHAL PRADHAN'; break; case '26': name = 'SHALAGHAYA SHARMA'; break; case '27': name = 'SALONI RAJPUT'; break; case '28': name = 'ANAMTA HASAN'; break; case '29': name = 'SANDHYA DANETI'; break; case '30': name = 'KUMKUM MANTRI'; break; case '31': name = 'BRISHTI SAMADDAR'; break; case '32': name = 'SHREE BISWAS'; break; case '33': name = 'TRISHAA KAMLAKAR'; break; case '34': name = 'SHEFALI THAKUR'; break; case '35': name = 'OSHNI ARYA'; break; case '36': name = 'NIKITA VAID'; break; case '37': name = 'ALIYA GHOSHAM'; break; case '38': name = 'AYESHA KAUR'; break; case '39': name = 'STARBOU SUPERMACY'; break; case '40': name = 'ANKIT MEWARA'; break; case '41': name = 'QUEEN MAIZ'; break; case '42': name = 'SAM KILLERZZ'; break; case '43': name = 'DARSHAN LY'; break; case '44': name = 'DILKUSH DIVYA'; break; case '45': name = 'ESHA BHATTARAI'; break; case '46': name = 'SHREYAL PANDEY'; break; case '47': name = 'SANDHYA RAGHAV'; break; case '48': name = 'PRIYANKA KUMAR SONI'; break;
          }
    //$("#celebModal").modal('show');
    this.modalRef = this.modalService.show(template, this.config);      
    $("#vidtitle").text(name);
    $("#datacelb").html('<video controls autoplay="true"  width="100%" onended="runsend('+id+')"><source src="//mango777.com/video/ss'+id+'.mp4" type="video/mp4" ></video>')
  }

  stopvideo(){
    $("#datacelb").html('');
    $("#vidtitle").text('');
    this.modalService.hide();
  }

}
